import { takeLatest } from 'redux-saga/effects';

import * as inProductMarketingActions from '../actions';

import { sendEmailSaga, fetchUpsellAdsSaga } from './inProductMarketing';

/**
 * Root saga for `In Product Marketing`
 * Triggers sagas related to in product marketing
 *
 * @method inProductMarketingSaga
 * @type   {Generator}
 */
function* inProductMarketingSaga() {
    yield takeLatest(inProductMarketingActions.sendEmail.TRIGGER, sendEmailSaga);
    yield takeLatest(inProductMarketingActions.fetchUpsellAds.TRIGGER, fetchUpsellAdsSaga);
}

export default inProductMarketingSaga;

export { sendEmailSaga, fetchUpsellAdsSaga };
